import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { MetaPixelTracker } from './components/MetaPixelTracker';
import { Disclaimer } from './pages/Disclaimer';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { RefundPolicy } from './pages/RefundPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rlf5kqna9k1s">
      <MetaPixelTracker data-id="element-1" data-mp="2risy0r0e74jk" />
      <Routes data-id="element-2" data-mp="2mm2nej7cx15j">
        <Route path="/" element={<LandingPage data-id="element-4" data-mp="2mn5fgugf19n1" />} data-id="element-3" data-mp="2mmltn2nna13q" />
        <Route path="/politica-de-privacidad" element={<PrivacyPolicy data-id="element-6" data-mp="31ayrk56alu0v" />} data-id="element-5" data-mp="2mjpx9irg3khe" />
        <Route path="/terminos-y-condiciones" element={<TermsAndConditions data-id="element-8" data-mp="2wjqi594yq8np" />} data-id="element-7" data-mp="31c9vq63nh3si" />
        <Route path="/politica-de-reembolsos" element={<RefundPolicy data-id="element-10" data-mp="28tw6guwdqq51" />} data-id="element-9" data-mp="2wip54z4dzc3c" />
        <Route path="/descargo-de-responsabilidad" element={<Disclaimer data-id="element-12" data-mp="23vcjcr61v8b3" />} data-id="element-11" data-mp="28te3zgj4jfoo" />
      </Routes>
    </BrowserRouter>;
}